import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-animate_refresh",
  "use": "icon-animate_refresh-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-animate_refresh\">\n    <path d=\"M22.6527 19C21.5293 21.3649 19.1188 23 16.3264 23C13.534 23 11.1235 21.3649 10 19V22M10 13C11.1235 10.6351 13.534 9 16.3264 9C19.1188 9 21.5293 10.6351 22.6527 13V10\" stroke=\"#81818A\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n    </symbol>"
});
var result = sprite.add(symbol);
export default symbol